import React from 'react';
import styles from './AffiliateStats.module.css';

const STATS = [
    { value: '57.14%', label: 'L1 commission share' },
    { value: '4 tiers', label: 'of override depth' },
    { value: '$0', label: 'upfront cost to join' },
];

function AffiliateStats() {
    return (
        <section className={styles.section}>
            <div className={styles.inner}>
                <p className={styles.eyebrow}>THE NUMBERS</p>
                <div className={styles.grid}>
                    {STATS.map((stat) => (
                        <div key={stat.label} className={styles.card}>
                            <p className={styles.statValue}>{stat.value}</p>
                            <p className={styles.statLabel}>{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default AffiliateStats;
